
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import RecordsHero from './components/RecordsHero';
import QuoteBlock from './components/QuoteBlock';

const RecordsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <RecordsHero />
      <QuoteBlock />
      <Footer />
    </div>
  );
};

export default RecordsPage;
